import { Alert } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react'
import SnackbarContext from '../contexts/SnackbarContext';
import { postActivateUser } from '../config/apiRoutes';
import { useNavigate, useParams } from 'react-router';
import { confirmSignupDto } from '../models/User';
import { useTranslation } from 'react-i18next';
import { homePageRoute, loginPageRoute, usePathReconstructor, welcomePageRoute } from '../config/pageRoutes';
import PageContainer from '../containers/PageContainer';
import BigLoader from '../common/BigLoader';
import PrimaryButton from '../buttons/PrimaryButton';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

type Props = {}

const ConfirmSignupPage = (props: Props) => {
    const [isLoading, setIsLoading] = useState(true);
    const snackbar = useContext(SnackbarContext);
    const params = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { copyParamsFromPath } = usePathReconstructor();
    const [isActivationValid, setIsActivationValid] = useState(false);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        sendConfirmation();
    }, []);

    async function sendConfirmation() {
        const { token, userId } = params;
        if (token == null || userId == null) {
            setHasError(true);
            return snackbar.showMessage(t("auth.invalid_token"), "error");
        }
        const data: confirmSignupDto = {
            userId: parseInt(userId),
            token: token,
        }
        const response = await fetch(postActivateUser, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        });
        if (response.ok) {
            setIsActivationValid(true);
        } else {
            setHasError(true);
            snackbar.showMessage(t("auth.invalid_token"), "error");
        }
        setIsLoading(false);
    }

    async function handleNextClick() {
        navigate(copyParamsFromPath(loginPageRoute.path));
    }

    return (
        <div>
            <PageContainer>
                <div className="flex justify-center items-center px-6 pt-10">
                    <div className="bg-secondary-pale w-full md:w-[600px] text-center py-5 px-3">
                        {isLoading && (
                            <div className="my-6">
                                <BigLoader />
                                <div className="text-primary">
                                    {t("auth.auth_in_progress")}
                                </div>
                            </div>
                        )}
                        {!isLoading && isActivationValid && (
                            <div>
                                <CheckCircleOutlineIcon
                                    style={{ fontSize: 80, color: "#2E6A73" }}
                                />
                                <div className="text-2xl font-bold text-primary-dark">
                                    {t("auth.account_successfully_activated")}
                                </div>
                                <div className="mt-3">
                                    <PrimaryButton
                                        onClick={handleNextClick}
                                    >
                                        {t("auth.continue_to_home_page")}
                                    </PrimaryButton>
                                </div>
                            </div>
                        )}
                        {!isLoading && hasError && (
                            <div className="my-1">
                                <Alert severity="error" variant="filled">
                                    {t("auth.invalid_activation")}
                                </Alert>
                            </div>
                        )}
                    </div>
                </div>
            </PageContainer >
        </div >
    )
}

export default ConfirmSignupPage;